import { IApiSettingValue } from "src/utilities/interfaces/settingValues.api.interface";

export enum SettingValueStatus {
    INACTIVE = 0,
    ACTIVE = 1
}
  
export enum SettingValuesMenu{
    Materials = 10,
    Colors = 20,
    Shape = 30,
    PackagingType = 40,
    ProductFamily = 50,
    ProductSubfamily = 60,
    ProductionColors = 70,
}

export enum SettingValuesPackagingType {
    BIG_BAG = 10,
    BUNDLE = 20,
    TANKER = 30,
    BAGS = 40,
    BULK = 50,
    PALLET = 60,
    CRATES = 70,
    BOXES = 80,
}

export class SettingValuesHelper {
    /**
    * Da el nombre completo de un material con el formato color-shape-material
    * @param color Datos del color
    * @param shape Datos de la forma
    * @param material Datos del material
    * @returns Nombre completo del material
    */
    public static FullNameMaterial(material: IApiSettingValue, color: IApiSettingValue,shape: IApiSettingValue): string {
        return ((material?.name ? material.name : '') + '-' + (color?.name ? color.name : '') + '-' + (shape?.name ? shape.name : ''))?.replace(/^-/, '');
    }

    public static SettingValuesRawMaterialsList = [SettingValuesMenu.Materials, SettingValuesMenu.Colors, SettingValuesMenu.Shape];
    public static SettingValuesProductsList = [SettingValuesMenu.PackagingType, SettingValuesMenu.ProductFamily, SettingValuesMenu.ProductSubfamily, SettingValuesMenu.ProductionColors];
}
